import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

export const FETCH_ONLINE_HOMEWORK_REQUEST = 'FETCH_ONLINE_HOMEWORK_REQUEST';
export const FETCH_ONLINE_HOMEWORK_SUCCESS = 'FETCH_ONLINE_HOMEWORK_SUCCESS';
export const FETCH_ONLINE_HOMEWORK_FAILURE = 'FETCH_ONLINE_HOMEWORK_FAILURE';

const buildHomeworkUrl = (groupId) => buildUrl(`/groups/${groupId}/online-homework-results`);

export function fetchOnlineHomeworkIfNeeded(groupId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildHomeworkUrl(groupId) })) {
      return false;
    }

    return dispatch(fetchOnlineHomework(groupId));
  };
}

export function fetchOnlineHomework(groupId) {
  return (dispatch) => {
    const url = buildHomeworkUrl(groupId);
    const method = 'GET';

    return dispatch(fetchOnlineHomeworkRequest()).payload
      .then((response) => dispatch(fetchOnlineHomeworkSuccess(response)))
      .catch((error) => dispatch(fetchOnlineHomeworkFailure(error)));

    function fetchOnlineHomeworkRequest() {
      return ApiCall.createAction({
        type: FETCH_ONLINE_HOMEWORK_REQUEST,
        payload: fetch(url),
        url,
        method,
        groupId,
      });
    }

    function fetchOnlineHomeworkSuccess(payload) {
      return ApiCall.createAction({
        type: FETCH_ONLINE_HOMEWORK_SUCCESS,
        payload,
        url,
        method,
        groupId,
      });
    }

    function fetchOnlineHomeworkFailure(error) {
      return ApiCall.createAction({
        type: FETCH_ONLINE_HOMEWORK_FAILURE,
        error,
        url,
        method,
        groupId,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/OnlineHomework/actions.js